import React from 'react';

import LabelInfoWithDescription from '../../../../../../components/LabelInfoWithDescription';
import LabelInfo from '../../../../../../components/LabelInfo';
import { IUserGradeInfoViewModel } from './UserGradeInfoViewModel';

const AccountUserDetailGradeInfo = (props: IUserGradeInfoViewModel): JSX.Element => {
  const {
    currentGrade,
    nextGrade,
    currentGradePeriod,
    nextGradePeriod,
    purchaseCountInDuration,
    purchaseAmountInDuration,
    purchaseCountStandards,
    purchaseAmountStandards,
  } = props;

  return (
    <div className="account-user-detail-section">
      <div className="title">유저 등급 정보</div>

      <div className="account-user-detail-section-content">
        <div className="form-wrap">
          <LabelInfoWithDescription
            label="현재 등급"
            info={currentGrade}
            description={{
              title: '현재 등급 산정 기간',
              message: <p>{currentGradePeriod}</p>,
            }}
          />
          <LabelInfoWithDescription
            label="구매 개수"
            labelSubInfo="다음달 등급 산정에 반영되는 구매 개수입니다."
            info={purchaseCountInDuration}
            description={{
              title: '등급 기준(구매 개수)',
              message: (
                <div className="form-wrap">
                  {purchaseCountStandards.map((gradeStandard) => (
                    <LabelInfo
                      key={gradeStandard.gradeName}
                      label={gradeStandard.gradeName}
                      info={gradeStandard.standard}
                    />
                  ))}
                </div>
              ),
            }}
          />
        </div>

        <div className="form-wrap">
          <LabelInfoWithDescription
            label="다음달 예상 등급"
            info={nextGrade}
            description={{
              title: '다음달 등급 산정 기간',
              message: <p>{nextGradePeriod}</p>,
            }}
          />
          <LabelInfoWithDescription
            label="구매 금액"
            labelSubInfo="다음달 등급 산정에 반영되는 구매 금액입니다."
            info={purchaseAmountInDuration}
            description={{
              title: '등급 기준(구매 금액)',
              message: (
                <div className="form-wrap">
                  {purchaseAmountStandards.map((gradeStandard) => (
                    <LabelInfo
                      key={gradeStandard.gradeName}
                      label={gradeStandard.gradeName}
                      info={gradeStandard.standard}
                    />
                  ))}
                </div>
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountUserDetailGradeInfo;
